<template lang="pug">
  #LabelCreate.container-width
    h5.text-center.pt-2 編輯顧客標籤
    .px-3
      ValidationObserver.w-100(
        ref="form"
        tag="label"
        @submit.stop.prevent="submitHandler",
        class="mb-0"
      )
        b-form-group(
          class="mb-0"
        )
          ValidationProvider(
            rules="required",
            ref="inputValLabel"
          )
            label(
              for="label"
            )
              code *
              span 顧客標籤：
            b-form-input(
              id="label",
              type="text",
              required,
              trim,
              :state="validState('label')",
              v-model="label",
              aria-describedby="input-live-help input-name-live-feedback",
              placeholder="請輸入顧客標籤"
            )
            b-form-invalid-feedback(
              id="input-name-live-feedback"
            )
              span 此欄不可為空
      p 標籤內共
        code.px-1 {{ users.length }}
        | 位名單
      .row.mb-5.word-break-all
        .col-3(
          v-for="(user,index) in users",
          :key="user.id"
        )
          ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
            :id="user.id",
            :profileUrl="user.img",
            :cancelProfile="true"
            :style="{ 'width': '50px', 'height': '50px' }"
            @cancelProfileImgHandler="cancelProfileHandler",
          )
          small.d-block.text-center.mt-1 {{ user.name }}
        .col-3.text-center
          .border.border-gray-light-2.bg-gray-light.rounded-circle.mx-auto.d-flex.align-items-center.justify-content-center.mb-1(
            style="width: 50px;height: 50px;",
            @click="openUsersModelHandler()"
          )
            i.fas.fa-plus.text-disable-light.fa-lg
          small.d-block.text-center 新增名單
      .row
        .col-6
          b-button(
            variant="primary",
            block,
            @click="$router.push({ name: 'sa-label-index' })"
          ) 取消
        .col-6
          b-button(
            variant="primary",
            block,
            @click="submitHandler()"
          ) 儲存
    usersModel(
      title="選擇顧客"
    )
</template>

<script>
import { SM_LABEL_INDEX } from '@/router/sm/label';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'; // 檢查套件
import { required } from 'vee-validate/dist/rules';
import usersModel from '@/components/customerModel/usersModel.vue';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';

// 測試圖片
import userExOneUrl from '@/assets/images/example/sa_1.png';
import userExTwoUrl from '@/assets/images/example/sa_2.png';
import userExThreeUrl from '@/assets/images/default/defaultImg.png';

const _ = require('lodash');

// 獲取所有驗證條件
extend('required', {
  ...required,
  message: '此欄不可為空'
});

export default {
  name: 'LabelEdit',
  components: {
    ValidationProvider,
    ValidationObserver,
    usersModel,
    ProfilePhotoSticker
  },
  data() {
    return {
      label: null,
      users: [
        {
          id: 0,
          name: 'Patty',
          nickName: '小白兔',
          bind_at: '2020/06/29',
          img: userExOneUrl,
          labels: [
            {
              id: 0,
              label: '美白'
            },
            {
              id: 1,
              label: 'VIP'
            }
          ]
        },
        {
          id: 1,
          name: 'Aaron',
          nickName: '強強滾',
          bind_at: '2020/06/29',
          img: userExTwoUrl,
          labels: [
            {
              id: 0,
              label: '修護'
            },
            {
              id: 1,
              label: 'VIP'
            }
          ]
        },
        {
          id: 2,
          name: 'Ariby',
          nickName: '土豪哥',
          bind_at: '2020/10/29',
          img: userExThreeUrl,
          labels: [
            {
              id: 0,
              label: '中實戶'
            }
          ]
        }
      ]
    };
  },
  methods: {
    validState() {
      const vm = this;
      if (vm.label !== null) {
        return vm.label ? true : false;
      }
      return null;
    },
    openUsersModelHandler() {
      this.$EventBus.$emit('openUsersModel');
    },
    async submitHandler() {
      const vm = this;
      const isValid = await this.$refs.form.validate();
      console.log(isValid);
      if (!isValid) {
        if (vm.label === null) {
          vm.label = '';
        }
        vm.$swal.fire({
          icon: 'error',
          title: '請填妥必填欄位或格式輸入錯誤'
        });
      } else {
        // TODO: 送出選擇的使用者
        vm.$swal.fire({
          title: '表單送出中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            vm.$swal.showLoading();
          }
        });
        setTimeout(() => {
          vm.$swal.close();
          vm.$router.push({
            name: SM_LABEL_INDEX
          });
        }, 2000);
      }
    },
    cancelProfileHandler(id) {
      const vm = this;
      const key = _.findKey(vm.users, (user) => user.id === id);
      vm.users.splice(key, 1);
    }
  }
};
</script>

<style>

</style>
